import { JsonObject, UiOption } from '@/lib/helpers';
import { startCase } from 'lodash';

export class AuditLogSettingsModel {
  version: string;
  generatedAt: string;
  categories: { category: string; actions: string[] }[];
  allCategories: string[];
  allActions: string[];

  constructor(props: JsonObject = {}) {
    this.version = props.version as string;
    this.generatedAt = props.generatedAt as string;
    this.categories = props.categories as { category: string; actions: string[] }[];
    this.allCategories = (props.allCategories as string[]) || [];
    this.allActions = (props.allActions as string[]) || [];
  }

  get allActionsOptions(): UiOption[] {
    return (
      this.allActions.map((action) => ({
        label: startCase(action),
        value: action,
      })) || []
    );
  }

  get allCategoriesOptions(): UiOption[] {
    return (
      this.allCategories.map((category) => ({
        label: startCase(category),
        value: category,
      })) || []
    );
  }
}
